import { usePostPortfolioBusinessLoansMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioBusinessLoansMutation";
import { BusinessLoansProductCategoryKeyEnum } from "web_myplann/Infrastructure/Api/Api";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { BUSINESS_LOANS_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/BusinessLoansForm/businessLoansFormDefaults";
import { getBusinessLoansFormSchema } from "web_myplann/Portfolio/Forms/BusinessLoansForm/businessLoansFormSchema";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateBusinessLoansForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioBusinessLoansMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getBusinessLoansFormSchema(t),
		defaultValues: BUSINESS_LOANS_FORM_DEFAULT_VALUES,
		mutate: ({ change, ...portfolioFields }, options) =>
			mutate(
				{
					...portfolioFields,
					initialChange: change,
					productCategory: BusinessLoansProductCategoryKeyEnum.BusinessLoans,
				},
				options,
			),
		successRoute: Routing.Portfolio.PortfolioAddBusinessLoansSuccess.path(),
	});

	return { form, onSubmit, isPending };
};
